import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (7 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisTalep = {
  CreateRequest(token, request, type, userID) {
    const requestSource = request && typeof request === "object" ? request : {};
    const data = {
      request: request,
      type: type,
      userID: userID
    };
    if (requestSource.isWarehouseExit !== undefined) data.isWarehouseExit = requestSource.isWarehouseExit;
    if (requestSource.sourceStorageOperationID) data.sourceStorageOperationID = requestSource.sourceStorageOperationID;
    if (requestSource.sourceRoomNo) data.sourceRoomNo = requestSource.sourceRoomNo;
    return axios({
      method: "post",
      url: `${API_URL}flow/create-request`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data
    });
  },
  UpdateRequest(token, requestID, request, attachments) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-request`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        requestID: requestID,
        request: request,
        attachments
      }
    });
  },
  UpdateRequestStatus(token, requestID, status) {
    const normalizedStatus =
      status === null || status === undefined || status === ""
        ? status
        : Number.isNaN(Number(status))
          ? status
          : Number(status);

    const data = {
      requestID: requestID,
      status: normalizedStatus
    };
    return axios({
      method: "post",
      url: `${API_URL}flow/request-change-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data
    });
  },
  GetMyRequestsCustomer(token, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-requests`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        withCustomerInfos: true
      }
    });
  },
  GetAllRequests(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-requests`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        withCustomerInfos: true
      }
    });
  },
  GetRequestById(token, requestID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-requests`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { requestID, withCustomerInfos: true },
    });
  },

  DeleteRequest(token, requestID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/delete-request`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        requestID: requestID
      }
    });
  },
};

export default servisTalep;
